import React, {Component} from 'react';
import _ from "lodash";
import {formatMoney} from "accounting-js";
import moment from "moment";
import {Control, Errors, Fieldset, Form} from "react-redux-form";
import {required} from "../field_validations";
import NotificationStatus from "../forms/notification_status";
import EditStatus from "../forms/edit_status";

export default class ReportsSummaryEditForm extends Component{
	render(){
		const { reports, revision} = this.props;
		const { modality } = this.props.match.params;
		const { summary } = reports;

		let rc = _.find(revision.permissions, (o) => {return o==='Create'}) ? true:false;

		return(
			<div className="columns is-centered">
				<div className="column is-11">
					<Form model="revision" onSubmit={(values) => this._submitForm(values)} onSubmitFailed={() => this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger')}>
						<h1 className="title is-6">DATOS DEL PROYECTO</h1>
						<table className="table is-fullwidth project-goal-table no-margin">
							<tbody>
							<tr>
								<td colSpan={2} style={{width: '50%'}}>
									<span className="help is-dark">Titular</span>
									<strong>{!_.isEmpty(summary.data) ? `${summary.data.agency.owner.name} ${summary.data.agency.owner.last_name} ${summary.data.agency.owner.slast_name}`:'---'}</strong>
								</td>
								<td colSpan={modality === 'modalidad-ii' ? 1:2} style={{width: modality === 'modalidad-ii' ? '25%':'50%'}}>
									<span className="help is-dark">Entidad</span>
									{modality==='modalidad-ii' ?
										<strong>{this._stateName()}</strong>
										:<strong>{!_.isEmpty(summary.data) && summary.data.agency.agenciable ? summary.data.agency.agenciable.name : '---'}</strong>}
								</td>
								{modality === 'modalidad-ii' ?
									<td colSpan={1} style={{width: '25%'}}>
										<span className="help is-dark">Municipio</span>
										<strong>{!_.isEmpty(summary.data) && summary.data.agency.agenciable ? summary.data.agency.agenciable.name : '---'}</strong>
									</td>
									:null}
							</tr>
							<tr>
								<td colSpan={4}>
									<span className="help is-dark">Instancia</span>
									<strong>{!_.isEmpty(summary.data) && summary.data.agency.name ? summary.data.agency.name : '---'}</strong>
								</td>
							</tr>
							<tr>
								<td colSpan={4}>
									<span className="help is-dark">Proyecto</span>
									<strong>{!_.isEmpty(summary.data) && summary.data.name ? summary.data.name : '---'}</strong>
								</td>
							</tr>
							<tr>
								<td style={{width: '25%'}}>
									<div className="columns">
										<div className="column is-1">
											<i className="fa fa-usd fa-2x" />
										</div>
										<div className="column">
											<span className="help is-dark">Monto aprobado</span>
											<strong> {summary.data.amounts && summary.data.amounts.goals ? `${formatMoney(summary.data.amounts.goals.total)}` : '---'}</strong>
										</div>
									</div>
								</td>
								<td style={{width: '25%'}}>
									<div className="columns">
										<div className="column is-1">
											<i className="fa fa-usd fa-2x" />
										</div>
										<div className="column">
											<span className="help is-dark">Monto ejercido</span>
											<strong> {summary.data.amounts && summary.data.amounts.goals ? `${formatMoney(summary.data.amounts.goals.spent)}` : '---'}</strong>
										</div>
									</div>
								</td>
								<td style={{width: '25%'}}>
									<div className="columns">
										<div className="column is-1">
											<i className="fa fa-usd fa-2x" />
										</div>
										<div className="column">
											<span className="help is-dark">Monto por ejercer</span>
											<strong> {summary.data.amounts && summary.data.amounts.goals ? `${formatMoney(summary.data.amounts.goals.missing)}` : '---'}</strong>
										</div>
									</div>
								</td>
								<td style={{width: '25%'}}>
									<div className="columns">
										<div className="column is-1">
											<i className="fa fa-calendar" />
										</div>
										<div className="column">
											<span className="help is-dark">Periodo de ejecución</span>
											<strong>{_.capitalize(moment(summary.data.execution_start).format('MMMM YYYY'))} a {_.capitalize(moment(summary.data.execution_end).format('MMMM YYYY'))}</strong>
										</div>
									</div>
								</td>
							</tr>
							</tbody>
						</table>

						<h1 className="title is-6">DOCUMENTOS</h1>
						<table className="is-fullwidth table project-goal-table no-margin">
							<Fieldset model=".reports.summary.body" component="tbody">
								{summary.data ?
									_.map(summary.data.documents_items, (item, d) => {
										let summaryRevision = !_.isEmpty(revision.reports.summary.body) && !_.isEmpty(revision.reports.summary.body[item.id]) ? revision.reports.summary.body[item.id]: undefined
										let summaryRevisionAllowEdit = summaryRevision && !_.isEmpty(summaryRevision.allow_edit) ? summaryRevision.allow_edit:'false';
										return (
											<tr key={d}>
												<td colSpan={3}>
													<div className="field">
														<div className="control">
															<a target="_blank" className="button is-info" href={summary.edit[item.slug]} disabled={summary.edit[item.slug] ? false:true}>
																<span className="icon"><i className="fa fa-link" /></span>
																<span>{`Ver "${item.name}"`}</span>
															</a>
														</div>
													</div>
													<div className="field has-addons">
														<div className="control">
															<div className="select">
																<Control model={`[${item.id}].status`} key={`status_${item.id}`} id={`status_${item.id}`} component={ NotificationStatus } defaultValue={summaryRevision && summaryRevision.status ? summaryRevision.status : 'success'}  changeAction={(model,value) => this._changeStatus(model,value, {id: item.id, model:`revision.reports.summary.body[${item.id}].id`})} errors={{required}} validateOn="change"/>
															</div>
															<Errors model={`[${item.id}].status`} show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
														</div>
														<div className="control is-expanded">
															<Control.text model={`[${item.id}].comment`} key={`comment_${item.id}`} id={`comment_${item.id}`} className="input" placeholder="Comentario"/>
														</div>
														<div className="control">
															<div className="select">
																<Control model={`[${item.id}].allow_edit`} key={`edit_status_${item.id}`} id={`edit_status_${item.id}`} component={EditStatus} defaultValue={summaryRevisionAllowEdit}/>
															</div>
														</div>
													</div>
												</td>
											</tr>
										)
									})
									:''}
							</Fieldset>
						</table>

						{!_.isEmpty(revision.notifications_types) ?
							<div className="fieldset">
								<legend>NOTIFICACIÓN</legend>
								<div className="columns">
									<div className="column">
										<div className="field is-grouped is-grouped-multiline">
											<div className="control">
												<label htmlFor="" className="label">Tipo de notificación</label>
												<div className="select">
													<Control.select model=".reports.summary.notification_type_id" id="notification_type_id" >
														<option value="" defaultValue>--- Tipo ---</option>
														{_.map(revision.notifications_types, (opc, k) => {
															return <option value={opc.id} key={k}>{opc.name}</option>
														})}
													</Control.select>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							:''}

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-large" onClick={() => this.props.history.goBack()}>
									Regresar
								</button>
							</div>

							{rc ?
								<div className="control">
									<Control.button model="revision" className="button is-large is-primary">
										Guardar
									</Control.button>
								</div> :''}
						</div>
					</Form>
				</div>
			</div>
		)
	}

	_submitForm(values){
		let { modality, state, municipality } = this.props.match.params;
		this.props.saveRevisionReportsSummary(modality, state, municipality, values);
	}

	_stateName() {
		let { entities, reports } = this.props;
		if(!_.isEmpty(reports.summary.data)){
			let state = _.find(entities.list, {id: reports.summary.data.agency.agenciable.state_id});
			return state ? state.name : '---'
		}else {
			return '---'
		}
	}

	_changeStatus(model, values, field) {
		this.props.change(model, values);
		this.props.change(field.model, field.id);
	}
}


// WEBPACK FOOTER //
// ./src/elements/revision/reports_summary.jsx